import {
    CContainer,
    CRow,
    CCol,
    CCard,
    CCardBody,
    CButton,
} from '@coreui/react';
import { Language } from '../../language/English';
import { useNavigate } from 'react-router-dom';
import { PAGE_LOGIN } from '../../PagesNames';

const UnAuthorized = () => {
    const navigate = useNavigate();
    return (
        <CContainer
            fluid
            className="min-vh-100 d-flex align-items-center justify-content-center bg-light"
        >
            <CRow className="w-100 justify-content-center">
                <CCol md={6} lg={4}>
                    <CCard className="shadow-sm border-0">
                        <CCardBody className="text-center p-4">
                            <h2 className="mb-3 text-danger fw-bold">
                                {Language.UNAUTHORIZED_ACCESS}
                            </h2>
                            <p className="text-muted mb-0">
                                {Language.YOU_DONT_HAVE_PERMISSION}
                                <br />
                                {Language.PLEASE_LOGIN_WITH_VALID_ADMIN_ACCOUNT}
                            </p>
                            <CButton
                                color="primary"
                                className="px-4 mt-2"
                                onClick={() => navigate(PAGE_LOGIN)}
                            >
                                {Language.LOGIN}
                            </CButton>
                        </CCardBody>
                    </CCard>
                </CCol>
            </CRow>
        </CContainer>
    );
};

export default UnAuthorized;
